import { render } from "./index.vue?vue&type=template&id=af0a9f04&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=af0a9f04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af0a9f04"

export default script